module.exports = __webpack_public_path__ + "static/media/kamila.556aa481.ogg";